import { CreatePatientBody } from "@bezbolisno/contracts/patients";
import { t } from "@bezbolisno/i18n";
import { Card } from "@bezbolisno/ui/card";
import { createFileRoute, Link, useNavigate } from "@tanstack/react-router";
import { PageHeader } from "../../../components/page-header";
import { PatientFormFields } from "../../../components/patient-form-fields";
import { PendingButton } from "../../../components/pending-button";
import { api, expectOk } from "../../../lib/api";
import { keys } from "../../../lib/keys";
import { parseWith, useFormMutation } from "../../../screens/patients/form";

export const Route = createFileRoute("/_authed/patients/new")({
  component: NewPatientPage,
});

function NewPatientPage() {
  const navigate = useNavigate();
  const { state, pending, submit } = useFormMutation({
    parse: (f) => parseWith(CreatePatientBody, f),
    run: async (body) => expectOk(await api.patients.create({ body }), 201),
    invalidate: [keys.patients, keys.rail, ["dashboard"]],
    // Land on the new patient's workspace.
    onSuccess: ({ id }) => navigate({ to: "/patients/$patientId", params: { patientId: id } }),
  });

  return (
    <div className="fade-in patient-form-page">
      <Link to="/patients" className="back-link">
        <svg
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          aria-hidden="true"
        >
          <path d="M15 6l-6 6 6 6" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
        {t.patientForm.back}
      </Link>
      <PageHeader title={t.patientForm.add} />

      <Card className="p-6">
        <form onSubmit={submit} className="grid gap-6">
          <PatientFormFields />
          {!state.ok && state.error ? (
            <p className="callout callout--danger" role="alert">
              {state.error}
            </p>
          ) : null}
          <div className="flex gap-3 justify-end">
            <Link to="/patients" className="btn btn--ghost">
              {t.common.cancel}
            </Link>
            <PendingButton pending={pending} pendingLabel={t.common.creating}>
              {t.patientForm.submit}
            </PendingButton>
          </div>
        </form>
      </Card>
    </div>
  );
}
